import { Container, H1, Paragraph, YStack, Text, XStack, Button } from '@holo/ui';
import { Link } from '@holo/link';
import Image from 'next/image';
import cropPlanningFieldImage from 'public/img/crop-planning-field.png';
import cropPlanningAssessmentImage from 'public/img/crop-planning-assessment.png';
import cropPlanningPlantedImage from 'public/img/crop-planning-planted.png';

const SaleHero = () => {
  return (
    <YStack borderBottomWidth={1} borderColor="$border">
      <Container>
        <YStack tag="section" alignItems="center" pt="$20" pb="$30" $md={{ py: '$30' }}>
          <H1 fontSize="$32" $md={{ fontSize: '60px' }} textAlign="center">
            The future of farming runs on{' '}
            <Text color="$accent" fontSize="inherit">
              holo
            </Text>
          </H1>
          <Paragraph mt="$4" lineHeight="$2" textAlign="center" fontSize="$18" color="$contrastPale">
            One platform for all your farm and sales operations.
          </Paragraph>
          <XStack mt="$12" mb="$16">
            <Button size="lg">
              <Link href="https://calendly.com/holoag/demo-holo-platform" target="_blank" rel="noopener noreferrer">
                Get a demo
              </Link>
            </Button>
          </XStack>
          <YStack position="relative" mt="$8">
            <Image
              src={cropPlanningFieldImage}
              priority
              loading="eager"
              alt="Crop planning field"
              style={{
                width: '85vw',
                maxWidth: 700,
                height: 'auto',
              }}
            />
            <YStack position="absolute" bottom="7%" left="-11%">
              <Image
                src={cropPlanningAssessmentImage}
                alt="Crop planning assessment"
                style={{
                  width: '40vw',
                  maxWidth: 256,
                  height: 'auto',
                }}
              />
            </YStack>
            {/* @ts-ignore - style transform */}
            <YStack position="absolute" top="50%" right="-10%" style={{ transform: 'translateY(-50%)' }}>
              <Image
                src={cropPlanningPlantedImage}
                alt="Crop planning planted"
                width={256}
                height={597}
                style={{
                  width: '40vw',
                  maxWidth: 256,
                  height: 'auto',
                }}
              />
            </YStack>
          </YStack>
        </YStack>
      </Container>
    </YStack>
  );
};

export default SaleHero;
